import React from "react";
import styles from "./Benefits.module.css";

const Benefits = () => {
  return (
    <div className={styles.benefits}>
      <div className={styles.infoBox}>
        <i className={`pi pi-globe ${styles.boxIcon}`}></i>
        <h1 className={styles.title}>Para el mundo real</h1>
        <p className={styles.description}>
          Nuestros cursos están diseñados para ayudarte a forjar las habilidades
          más demandadas en la industria financiera.
        </p>
      </div>
      <div className={styles.infoBox}>
        <i className={`pi pi-star-fill ${styles.boxIcon}`}></i>
        <h1 className={styles.title}>Educación experta</h1>
        <p className={styles.description}>
          Nuevos métodos y técnicas explicadas por expertos en finanzas, gestión
          de riesgos, transformación digital y más.
        </p>
      </div>

      <div className={styles.infoBox}>
        <i className={`pi pi-book ${styles.boxIcon}`}></i>
        <h1 className={styles.title}>Eleva tu aprendizaje</h1>
        <p className={styles.description}>
          Eleva tu aprendizaje Accede a un espacio virtual con educación
          financiera para todos los niveles.
        </p>
      </div>
    </div>
  );
};

export default Benefits;
